import { render } from "./VisualizarPaciente.vue?vue&type=template&id=34a5286d&scoped=true"
import script from "./VisualizarPaciente.vue?vue&type=script&lang=js"
export * from "./VisualizarPaciente.vue?vue&type=script&lang=js"

import "./VisualizarPaciente.vue?vue&type=style&index=0&id=34a5286d&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a5286d"]])

export default __exports__